import fetch from '@/utils/fetch/index'

export interface LoginParams {
  /** appId */
  appId: number
  /** 渠道号 */
  channel?: number
  /** 登录密码串 */
  loginStr: string
  /** sessionId */
  sessionId?: number
}

export interface DevOrderParams {
  /** 金额 */
  amt: number
  /** 手机号码 不是用来判断用户身份的 */
  phone: string
  /** 外部流水号 */
  outTradeNo: number
  orderSrc: string
  /** 用户身份判断 本地开发环境登录的是你配置的那个 APP里是APP用户的真实userId */
  aomiUserId: string
}

/**
 * 生成一笔订单数据 - test和uat环境
 * @param params
 * @returns
 */
export function genOrderParamsForTest(params: DevOrderParams) {
  return fetch('/test/genPayParam', {
    params,
  })
}

/**
 * 登录lifePay - test和uat环境
 * @param params
 * @returns
 */
export function loginLifePay(params: LoginParams) {
  return fetch('/customer/aomiRegiterOrLogin', {
    params,
  })
}
